/**
 * Product Recommendations RTL Fix
 *
 * The recommendation slider uses ProductRowScroller (webpack-bundled flickity)
 * which doesn't pass `rightToLeft: true`. On RTL stores (Hebrew, Arabic, etc.)
 * this makes the carousel render LTR. We watch for flickity to be initialized
 * inside [data-product-recommendations] and, if RTL is missing, destroy and
 * re-instantiate via window.Flickity (already patched by flickity-rtl-patch.js).
 */
(function () {
  'use strict';

  if (document.documentElement.dir !== 'rtl') return;

  function getFlickityInstance(el) {
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      return window.Flickity.data(el);
    }
    return null;
  }

  function fixRow(row) {
    if (!row || row.dataset.rtlFixed === 'true') return;
    if (!row.classList.contains('flickity-enabled')) return;
    if (row.classList.contains('flickity-rtl')) {
      row.dataset.rtlFixed = 'true';
      return;
    }

    var instance = getFlickityInstance(row);
    if (!instance || !window.Flickity) return;

    var opts = Object.assign({}, instance.options, { rightToLeft: true });
    try {
      instance.destroy();
    } catch (e) {
      return;
    }
    try {
      new window.Flickity(row, opts);
      row.dataset.rtlFixed = 'true';
    } catch (e) {
      // Silent fail — leave row as-is rather than break the page
    }
  }

  function watchContainer(container) {
    if (!container || container.dataset.rtlObserved === 'true') return;
    container.dataset.rtlObserved = 'true';

    // Try once immediately in case flickity is already up
    var existing = container.querySelector('[data-product-row].flickity-enabled');
    if (existing) fixRow(existing);

    var observer = new MutationObserver(function () {
      var row = container.querySelector('[data-product-row].flickity-enabled');
      if (row) fixRow(row);
    });
    observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    var containers = document.querySelectorAll('[data-product-recommendations]');
    containers.forEach(watchContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
